'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Progress = require('./Progress');

var _Progress2 = _interopRequireDefault(_Progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Progress2["default"];
module.exports = exports['default'];